import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 grid-bg">
      <Card className="max-w-md w-full p-8 text-center">
        <div className="flex justify-center mb-6"><Logo size={48} /></div>
        <XCircle size={64} weight="fill" className="mx-auto text-amber-500" />
        <h2 className="text-2xl font-extrabold mt-4" style={{ fontFamily: "Manrope" }}>Pagamento cancelado</h2>
        <p className="text-muted-foreground mt-2 text-sm">Você pode tentar de novo a qualquer momento.</p>
        <Link to="/empresa"><Button data-testid="btn-back-cancel" className="mt-6 bg-blue-600 hover:bg-blue-700 hover:text-white text-white">Voltar ao painel</Button></Link>
      </Card>
    </div>
  );
}
